export const sitePages = [
  {
    text: "Page d'accueil",
    value: "/",
  },
  {
    text: "Page Le Centre",
    value: "/le-centre",
  },
  {
    text: "Page Nos formules",
    value: "/nos-formules",
  },
  {
    text: "Page Services",
    value: "/services",
  },
  {
    text: "Page Création",
    value: "/creation",
  },
  {
    text: "Page Actualités",
    value: "/actualites",
  },
  {
    text: "Page Contact",
    value: "/contact",
  },
  {
    text: "Page Mentions Légales",
    value: "/mentions-legales",
  },
];
